"use strict";

exports.__esModule = true;
exports.OMIT_FIELDS = void 0;
var OMIT_FIELDS = ['_id', 'communityId', 'registrationOpened', 'registrationManuallyApproved', 'baseUrl', 'sectionUrl', 'mediaQuota'];
exports.OMIT_FIELDS = OMIT_FIELDS;